// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v5-collapse{transition:height .3s ease 0s}.v5-collapse.is-collapse{overflow:hidden}", ""]);
// Exports
module.exports = exports;
